import React from 'react';
import dayjs from 'dayjs';

import localizedFormat from 'dayjs/plugin/localizedFormat';
import Button from '../../../components/Button/Button';
import Modal from '../../../components/Modal/Modal';
import { UserStatus } from '../../../constants/constants';
import useScreenQuery from '../../../hooks/useScreenQuery';
import { parseApiError } from '../../../utils/parseApiError';
import { TitleHeader } from '../sharedStyledComponents';
import { BodyContainer } from '../sharedStyles';
import { usBreakPeriods } from './breakData';
import { PortalTakeABreakProps } from './PortalTakeABreak';
import { BreakInfoSection, HighlightedText, ModalText, StyledSelectInput, TermItemText } from './sharedComponents';

dayjs.extend(localizedFormat);

const USView = ({ brandName, user, handleSubmit, sending, errors }: Omit<PortalTakeABreakProps, 'isUS'>) => {
	const { isSmall } = useScreenQuery();
	const [showModal, setShowModal] = React.useState(false);
	const [period, setPeriod] = React.useState<string | null>(null);

	return (
		<>
			{showModal && period && (
				<Modal onClose={() => setShowModal(false)} title={`Confirm ${period || ''} Timeout`}>
					<ModalText isSmallScreen={isSmall}>
						Please note that this is a firm commitment. You will not be able to change your timeout period until your
						chosen timeframe has expired.
					</ModalText>
					<Button isLoading={sending} kind="danger" height={50} onClick={() => handleSubmit(period)}>
						{`Take ${period || 'a'} Timeout`}
					</Button>
					<Button height={50} onClick={() => setShowModal(false)}>
						Cancel
					</Button>
				</Modal>
			)}
			{isSmall && <TitleHeader title={'Take a timeout'} />}
			<BodyContainer isSmallScreen={isSmall}>
				<HighlightedText>If you take a timeout from gambling at {brandName} this is what happens next:</HighlightedText>
				<TermItemText>• You will not be able to play on the website during this period.</TermItemText>
				<TermItemText>• You will not receive any marketing emails or promotions.</TermItemText>
				<TermItemText>• You will not be able to deposit or place any wagers. All pending bets will stand.</TermItemText>
				<TermItemText>• You can still log in and withdraw funds from your account.</TermItemText>
				<TermItemText>
					• If vou would like to withdraw funds without logging into your account, please contact customer support.
				</TermItemText>
				{user?.status?.id === UserStatus.Break ? (
					<BreakInfoSection isSmallScreen={isSmall}>
						<p>Requested on {user && dayjs(user.break_applied_at).format('LL, h:mm A')}</p>
						<p>Your timeout ends on {user && dayjs(user.break_end_at).format('LL, h:mm A')}</p>
					</BreakInfoSection>
				) : (
					<>
						<StyledSelectInput
							isSmallScreen={isSmall}
							kind="white"
							label={'Select the length of the Timeout:'}
							placeholder={'Select period'}
							onChange={(e) => setPeriod(e.target.value)}
							error={parseApiError(errors, 'period')}
						>
							{usBreakPeriods.map((shortBreakPeriod) => (
								<option key={shortBreakPeriod.period} value={shortBreakPeriod.period}>
									{shortBreakPeriod.period}
								</option>
							))}
						</StyledSelectInput>
						<Button kind="white" disabled={!period} isLoading={sending} onClick={() => setShowModal(true)}>
							Take a Timeout
						</Button>
					</>
				)}
			</BodyContainer>
		</>
	);
};

export default USView;
